import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { fetchLatestReportDate as fetchLatestReportDateService, fetchReports as fetchReportsService } from 'services/modules/rhymscan/report';
import { fetchSeverities as fetchSeveritiesService } from 'services/modules/rhymscan/data';
import { setLoading } from 'stores/modules/idp/authreducer';

import Graph from './Graph';
import ThreatActorGeography from './ThreatActorGeography';
import SignificantThreats from './SignificantThreats';
import CurrentAnalysis from './CurrentAnalysis';
import Loader from 'components/Loader';

import { Card, CardContent } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';

function DashboardPage() {
  // Redux dispatch
  const dispatch = useDispatch();

  // Redux selectors
  const reportDateContainer = useSelector((state) => state.rsReport.latestReportDate);
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  const loadingContainer = useSelector((state) => state.auth.loading);
  const errorsContainer = useSelector((state) => state.rsReport.errors);

  // State Variable
  const [progress, setProgress] = useState(false);
  const [report, setReport] = useState("")

  // useEffect hook fetches the ECS severities
  useEffect(() => {
    dispatch(setLoading(true));
    const fetchSeveritiesData = async () => {
      await dispatch(fetchSeveritiesService({}));
    };
    fetchSeveritiesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect hook fetches the latest report date based on domain
  useEffect(() => {
    if (selectedCompanyContainer) {
      const fetchCompanyReport = async () => {
        const domain = selectedCompanyContainer.domain;
        let params = { domain: domain };
        dispatch(fetchLatestReportDateService({ params }));
      };
      fetchCompanyReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyContainer]);

  // useEffect hook fetches the latest report date based on domain
  useEffect(() => {
    if (selectedCompanyContainer && errorsContainer === "Report not found") {
      dispatch(setLoading(false));
      const fetchReport = async () => {
        const domain = selectedCompanyContainer.domain;
        let params = { domain: domain };
        let response = await fetchReportsService(params);
        let results = response?.data?.results
        let progress = results?.some(report => report?.reportStatus !== "CANCELLED")
        let report = results?.find(report => report?.reportStatus !== "CANCELLED")
        setReport(report)
        setProgress(progress)
      };
      fetchReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompanyContainer, errorsContainer]);

  return (
    <div className='form-card'>
      {loadingContainer && (
        <div className="loader-overlay-dashboard">
          <Loader />
        </div>
      )}

      {errorsContainer === "Report not found" ? (
        <div className="dived-card cell-items">
          <Card className="d-block py-3 cap-dashboard-container">
            <CardContent>
              <h5 className="rating-value" style={{ fontWeight: 'normal' }}>
                <InfoIcon className='cap-info-icon' /> <br />
                {progress ? (
                  <>
                    <div>The requested report is currently running</div>
                    <br />
                    <div>Report Id : <b>{report?.reportId}</b></div>
                    <div>Report Date : {report?.createdAt?.substring(0, 10)}</div>
                  </>
                ) : (
                  <>
                    <div>Welcome to the RHYMScan Dashboard</div>
                    <div>Please request for a new scan</div>
                  </>
                )}
              </h5>
            </CardContent>
          </Card>
        </div>
      ) : (
        <div>
          <div className="row wrapper-row rounded-10">
            <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-3 rating-flex">
              <Graph chartID="gauge-one" reportDate={reportDateContainer} />

              <div className="vertical-line"></div>
            </div>
            <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-9">
              <CurrentAnalysis />
            </div>
          </div>

          <div className="row mt-md col-gutter-md">
            <div className="col-8 col-xs-12 col-sm-12 col-md-12 col-lg-8 pt-0">
              <ThreatActorGeography />
            </div>
            <div className="col-4 col-xs-12 col-sm-12 col-md-12 col-lg-4 pt-0">
              <div className="significant-threat rounded-10">
                <SignificantThreats />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardPage;
